import { createGlobalStyle } from "styled-components";

const Fonts = createGlobalStyle`
  .Font_136_104_600 {
    font-size: 136px;
    line-height: 104px;
    font-weight: 600;
    letter-spacing: -0.03em;
  }

  .Font_80_88_600 {
    font-size: 80px;
    line-height: 88px;
    font-weight: 600;
    letter-spacing: -0.02em
  }

  .Font_64_72_600 {
    font-size: 64px;
    line-height: 72px;
    font-weight: 600;
    letter-spacing: -0.02em;
  }

  .Font_48_54_600 {
    font-size: 48px;
    line-height: 54px;
    font-weight: 600;
    letter-spacing: -0.02em;
  }

  .Font_48_48_600 {
    font-size: 48px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.06em;
  }

  .Font_40_48_600 {
    font-size: 40px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.02em;
  }

  .Font_40_48_400 {
    font-size: 40px;
    line-height: 48px;
    font-weight: 400;
    letter-spacing: -0.02em;
  }

  .Font_32_40_600 {
    font-size: 32px;
    line-height: 40px;
    font-weight: 600;
    letter-spacing: -0.016em;
  }

  .Font_32_32_600 {
    font-size: 32px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: -0.006em;
  }

  .Font_24_32_700 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    letter-spacing: -0.004em;
  }

  .Font_24_32_600 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: -0.006em;
  }

  .Font_24_32_450 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 450;
    letter-spacing: -0.006em;
  }

  .Font_24_32_400 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    letter-spacing: -0.006em;
  }

  .Font_18_26_700 {
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
    letter-spacing: 0.004em;
  }

  .Font_18_26_600 {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    letter-spacing: -0.004em;
  }

  .Font_18_26_450 {
    font-size: 18px;
    line-height: 26px;
    font-weight: 450;
    letter-spacing: 0;
  }

  .Font_18_26_400 {
    font-size: 18px;
    line-height: 26px;
    font-weight: 400;
    letter-spacing: 0;
  }

  .Font_16_22_700 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: 0.008em;
  }

  .Font_16_22_600 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: 0;
  }

  .Font_16_22_450 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 450;
    letter-spacing: 0;
  }

  .Font_14_20_600 {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: 0;
  }

  .Font_14_20_500 {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.002em;
  }

  .Font_14_20_450 {
    font-size: 14px;
    line-height: 20px;
    font-weight: 450;
    letter-spacing: 0.002em;
  }

  .Font_14_14_600 {
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    letter-spacing: 0.008em;
  }

  .Font_12_16_500 {
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0.004em;
  }

  .Font_12_16_450 {
    font-size: 12px;
    line-height: 16px;
    font-weight: 450;
    letter-spacing: 0.004em;
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .xl\:Font_136_104_600 {
      font-size: 136px;
      line-height: 104px;
      font-weight: 600;
      letter-spacing: -0.03em;
    }

    .xl\:Font_64_72_600 {
      font-size: 64px;
      line-height: 72px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .xl\:Font_48_48_600 {
    font-size: 48px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.06em;
  }

    .xl\:Font_48_54_600 {
      font-size: 48px;
      line-height: 54px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .xl\:Font_40_48_600 {
      font-size: 40px;
      line-height: 48px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .xl\:Font_32_40_600 {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      letter-spacing: -0.016em;
    }

    .xl\:Font_24_32_600 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .xl\:Font_24_32_450 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 450;
      letter-spacing: -0.006em;
    }

    .xl\:Font_18_26_700 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      letter-spacing: 0.004em;
    }

    .xl\:Font_18_26_600 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 600;
      letter-spacing: -0.004em;
    }

    .xl\:Font_18_26_450 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .xl\:Font_16_22_700 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      letter-spacing: 0.008em;
    }

    .xl\:Font_16_22_600 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .xl\:Font_16_22_450 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .xl\:Font_14_20_600 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .xl\:Font_14_20_500 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.002em;
    }

    .xl\:Font_14_20_450 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 450;
      letter-spacing: 0.002em;
    }

    .xl\:Font_12_16_500 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      letter-spacing: 0.004em;
    }

    .xl\:Font_12_16_450 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 450;
      letter-spacing: 0.004em;
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .lg\:Font_136_104_600 {
      font-size: 136px;
      line-height: 104px;
      font-weight: 600;
      letter-spacing: -0.03em;
    }

    .lg\:Font_64_72_600 {
      font-size: 64px;
      line-height: 72px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .lg\:Font_48_54_600 {
      font-size: 48px;
      line-height: 54px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .lg\:Font_48_48_600 {
    font-size: 48px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.06em;
  }


    .lg\:Font_40_48_600 {
      font-size: 40px;
      line-height: 48px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .lg\:Font_32_40_600 {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      letter-spacing: -0.016em;
    }

    .lg\:Font_24_32_600 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .lg\:Font_24_32_450 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 450;
      letter-spacing: -0.006em;
    }

    .lg\:Font_18_26_700 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      letter-spacing: 0.004em;
    }

    .lg\:Font_18_26_600 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 600;
      letter-spacing: -0.004em;
    }

    .lg\:Font_18_26_450 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .lg\:Font_16_32_600 {
      font-size: 16px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .lg\:Font_16_22_700 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      letter-spacing: 0.008em;
    }

    .lg\:Font_16_22_600 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .lg\:Font_16_22_450 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .lg\:Font_14_20_600 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .lg\:Font_14_20_500 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.002em;
    }

    .lg\:Font_14_20_450 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 450;
      letter-spacing: 0.002em;
    }

    .lg\:Font_12_16_500 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      letter-spacing: 0.004em;
    }

    .lg\:Font_12_16_450 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 450;
      letter-spacing: 0.004em;
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .md\:Font_136_104_600 {
      font-size: 136px;
      line-height: 104px;
      font-weight: 600;
      letter-spacing: -0.03em;
    }

    .md\:Font_64_72_600 {
      font-size: 64px;
      line-height: 72px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .md\:Font_48_54_600 {
      font-size: 48px;
      line-height: 54px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .md\:Font_48_48_600 {
    font-size: 48px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.06em;
  }


    .md\:Font_40_48_600 {
      font-size: 40px;
      line-height: 48px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .md\:Font_40_48_400 {
      font-size: 40px;
      line-height: 48px;
      font-weight: 400;
      letter-spacing: -0.02em;
    }

    .md\:Font_32_40_600 {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      letter-spacing: -0.016em;
    }

    .md\:Font_24_32_600 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .md\:Font_24_32_450 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 450;
      letter-spacing: -0.006em;
    }

    .md\:Font_24_32_400 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 400;
      letter-spacing: -0.006em;
    }

    .md\:Font_18_26_700 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      letter-spacing: 0.004em;
    }

    .md\:Font_18_26_600 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 600;
      letter-spacing: -0.004em;
    }

    .md\:Font_18_26_450 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .md\:Font_16_22_700 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      letter-spacing: 0.008em;
    }


    .md\:Font_16_32_600 {
      font-size: 16px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .md\:Font_16_22_600 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .md\:Font_16_22_450 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .md\:Font_16_24_450 {
      font-size: 16px;
      line-height: 24px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .md\:Font_14_20_600 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .md\:Font_14_20_500 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.002em;
    }

    .md\:Font_14_20_450 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 450;
      letter-spacing: 0.002em;
    }

    .md\:Font_12_16_600 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      letter-spacing: 0.008em;
    }

    .md\:Font_12_16_500 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      letter-spacing: 0.004em;
    }

    .md\:Font_12_16_450 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 450;
      letter-spacing: 0.004em;
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .sm\:Font_136_104_600 {
      font-size: 136px;
      line-height: 104px;
      font-weight: 600;
      letter-spacing: -0.03em;
    }

    .sm\:Font_64_72_600 {
      font-size: 64px;
      line-height: 72px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .sm\:Font_48_54_600 {
      font-size: 48px;
      line-height: 54px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .sm\:Font_48_48_600 {
    font-size: 48px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: -0.06em;
    }


    .sm\:Font_40_48_600 {
      font-size: 40px;
      line-height: 48px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .sm\:Font_32_40_600 {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      letter-spacing: -0.016em;
    }

    .sm\:Font_24_32_600 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .sm\:Font_24_32_450 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 450;
      letter-spacing: -0.006em;
    }

    .sm\:Font_18_26_700 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      letter-spacing: 0.004em;
    }

    .sm\:Font_18_26_600 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 600;
      letter-spacing: -0.004em;
    }

    .sm\:Font_18_26_450 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .sm\:Font_18_26_440 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 400;
      letter-spacing: 0;
    }

    .sm\:Font_16_22_700 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      letter-spacing: 0.008em;
    }

    .sm\:Font_16_22_600 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .sm\:Font_16_22_450 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .sm\:Font_14_20_600 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .sm\:Font_14_20_500 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.002em;
    }

    .sm\:Font_14_20_450 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 450;
      letter-spacing: 0.002em;
    }

    .sm\:Font_12_16_500 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      letter-spacing: 0.004em;
    }

    .sm\:Font_12_16_450 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 450;
      letter-spacing: 0.004em;
    }
  }

  @media(max-width: ${({ theme }) => `${theme.breakpoints.xs}px`}) {
    .xs\:Font_136_104_600 {
      font-size: 136px;
      line-height: 104px;
      font-weight: 600;
      letter-spacing: -0.03em;
    }

    .xs\:Font_64_72_600 {
      font-size: 64px;
      line-height: 72px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .xs\:Font_48_54_600 {
      font-size: 48px;
      line-height: 54px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .xs\:Font_40_48_600 {
      font-size: 40px;
      line-height: 48px;
      font-weight: 600;
      letter-spacing: -0.02em;
    }

    .xs\:Font_32_40_600 {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      letter-spacing: -0.016em;
    }

    .xs\:Font_24_32_600 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: -0.006em;
    }

    .xs\:Font_24_32_450 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 450;
      letter-spacing: -0.006em;
    }

    .xs\:Font_18_26_700 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      letter-spacing: 0.004em;
    }

    .xs\:Font_18_26_600 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 600;
      letter-spacing: -0.004em;
    }

    .xs\:Font_18_26_450 {
      font-size: 18px;
      line-height: 26px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .xs\:Font_16_22_700 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      letter-spacing: 0.008em;
    }

    .xs\:Font_16_22_600 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .xs\:Font_16_22_450 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 450;
      letter-spacing: 0;
    }

    .xs\:Font_14_20_600 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .xs\:Font_14_20_500 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.002em;
    }

    .xs\:Font_14_20_450 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 450;
      letter-spacing: 0.002em;
    }

    .xs\:Font_12_16_500 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      letter-spacing: 0.004em;
    }

    .xs\:Font_12_16_450 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 450;
      letter-spacing: 0.004em;
    }
  }
`;

export { Fonts };
